export function nameofFactory<T>() {
  return (name: keyof T) => name;
}
